// extracted by mini-css-extract-plugin
export default {"title":"UrineDipstick_title__rEMmM","readingInput":"UrineDipstick_readingInput__-v-MY"};